import { SerializationHelper } from '../utils/SerializationHelper'
import { AbstractModel } from './AbstractModel'
import { VehicleClass } from './VehicleClass'
import { VehicleImage } from './VehicleImage'
import { Http } from '@/lib/utils/Http'

export class Vehicle extends AbstractModel {
    public id: number | null = null;
    public vehicle_id: number | null = null;
    public teamId: number | null = null;
    public description: string | null = null;
    public breakdown: string | null = null;
    public brand: string | null = null;
    public type: string | null = null;
    public buildyear: number | null = null;
    public mileage: number | null = null;
    public horsepower: number | null = null;
    public price: number | null = null;
    public countryId = 0;
    public licensePlate = ''
    public responsibleCustomerId = -1
    public vehicleOwner = ''
    public createdAt: string | null = null;
    public updatedAt: string | null = null;
    public aktiv: number | null = null;
    public images: VehicleImage[] | null = null;
    public classes: VehicleClass[] = [];
    public imageId: number | null = null;
    public imagePath: string | null = null;

    public static async search (search: string) {
      const res = await Http.request(`/api/vehicle/search-admin/${search}`)
      return SerializationHelper.toInstanceArray(Vehicle, await res.json())
    }
}
